import { MBThemeColors } from 'typings/theme';

const palette: MBThemeColors = {
  common: {
    white: '#ffffff',
    black: '#000000',
  },
  yellow: {
    main: '#FFE600',
  },
  green: {
    main: '#44D62C',
    secondary: '#7DC64E',
  },
  primary: {
    main: '#4D4E58',
    light: '#3399CC',
    dark: '#237EAB',
    contrastText: '#fff',
  },
  secondary: {
    main: '#F5F5F7',
    light: '#E4E4E4',
    dark: '#fff',
  },
  blue: {
    main: '#FFE600',
    dark: '#F5DD00',
    light: '#2F80ED',
  },
  lightBlue: {
    main: '#E5F4FF',
  },
  grey: {
    900: '#333333',
    800: '#4d4e58',
    700: '#959595',
    600: '#4D4D4D',
    500: '#85858A',
    400: '#C4C4C4',
    300: '#E4E4E4',
    200: '#F5F5F7',
    100: '#A6A6A6',
    50: '#F2F2F2',
    150: '#EEEEE1',
    A100: '#BCBCBC',
    A200: '#B0B0B0',
    A400: '#707075',
    A700: '#27272C',
    overlay: '#f5f5f5',
  },
  info: {
    main: '#3399CC',
  },
  success: {
    main: '#7DC64E',
    light: '#44D62C',
    contrastText: '#fff',
  },
  warning: {
    main: '#FFD33C',
  },
  error: {
    main: '#ED6DB8',
    contrastText: '#fff',
  },
  orange: {
    main: '#FF7105',
    dark: '#f44336',
  },
  lime: {
    main: '#E6FA0A',
  },
};

export default palette;
